import { render, staticRenderFns } from "./Link2Icon.vue?vue&type=template&id=98160dde"
import script from "./Link2Icon.vue?vue&type=script&lang=js"
export * from "./Link2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports